"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _global_config = require("@/api/cfg/global_config");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'global_config',
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      listQuery: {
        page: 1,
        limit: 20,
        keywords: null
      },
      records: [],
      total: 0,
      listLoading: false,
      dialogVisible: false,
      globalConfigForm: {
        id: null,
        configCode: null,
        configName: null,
        configType: null,
        isUse: 1,
        note: ''
      },
      rules: {
        configCode: [{
          required: true,
          message: '请输入配置编码',
          trigger: 'blur'
        }, {
          max: 20,
          message: '配置编码长度不能超过20个字符',
          trigger: 'blur'
        }],
        configName: [{
          required: true,
          message: '请输入配置名称',
          trigger: 'blur'
        }, {
          max: 20,
          message: '配置名称长度不能超过20个字符',
          trigger: 'blur'
        }],
        configType: [{
          max: 20,
          message: '配置类型长度不能超过20个字符',
          trigger: 'blur'
        }],
        isUse: [{
          required: true,
          message: '请选择是否启用',
          trigger: 'change'
        }],
        note: [{
          max: 20,
          message: '备注信息长度不能超过20个字符',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.getPage();
  },
  methods: {
    search: function search() {
      this.listQuery.page = 1;
      this.getPage();
    },
    getPage: function getPage() {
      var _this = this;
      this.listLoading = true;
      (0, _global_config.globalConfigPage)(this.listQuery).then(function (res) {
        _this.records = res.records || [];
        _this.total = res.total || 0;
        _this.listLoading = false;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    handleCreate: function handleCreate() {
      this.dialogVisible = true;
      this.initFormData();
    },
    initFormData: function initFormData() {
      var _this2 = this;
      this.globalConfigForm = {
        id: null,
        configCode: null,
        configName: null,
        configType: null,
        isUse: 1,
        note: ''
      };
      this.$nextTick(function () {
        if (_this2.$refs.globalConfigForm) {
          _this2.$refs.globalConfigForm.clearValidate();
        }
      });
    },
    handleEdit: function handleEdit(row) {
      this.dialogVisible = true;
      this.globalConfigForm = {
        id: row.id,
        configCode: row.configCode,
        configName: row.configName,
        configType: row.configType,
        isUse: row.isUse,
        note: row.note
      };
    },
    handleDelete: function handleDelete(row) {
      var _this3 = this;
      this.$confirm('确认删除该配置吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _global_config.deleteGlobalConfig)(row.id).then(function () {
          _this3.$notify({
            title: '成功',
            message: '删除成功',
            type: 'success',
            duration: 3000
          });
          _this3.getPage();
        });
      }).catch(function () {});
    },
    handleStatusChange: function handleStatusChange(value, row) {
      var _this4 = this;
      var params = {
        id: row.id,
        configCode: row.configCode,
        configName: row.configName,
        configType: row.configType,
        isUse: value,
        note: row.note
      };
      (0, _global_config.updateGlobalConfig)(params).then(function () {
        _this4.$message.success('修改成功');
      }).catch(function () {
        // 如果更新失败，恢复原状态
        row.isUse = value === 1 ? 0 : 1;
      });
    },
    saveOrUpdate: function saveOrUpdate() {
      var _this5 = this;
      this.$refs['globalConfigForm'].validate(function (valid) {
        if (valid) {
          if (_this5.globalConfigForm.id) {
            _this5.update();
          } else {
            _this5.save();
          }
        }
      });
    },
    save: function save() {
      var _this6 = this;
      (0, _global_config.saveGlobalConfig)(this.globalConfigForm).then(function () {
        _this6.dialogVisible = false;
        _this6.$notify({
          title: '成功',
          message: '创建成功',
          type: 'success',
          duration: 3000
        });
        _this6.getPage();
      });
    },
    update: function update() {
      var _this7 = this;
      (0, _global_config.updateGlobalConfig)(this.globalConfigForm).then(function () {
        _this7.dialogVisible = false;
        _this7.$notify({
          title: '成功',
          message: '更新成功',
          type: 'success',
          duration: 3000
        });
        _this7.getPage();
      });
    }
  }
};